import { render } from "./App.vue?vue&type=template&id=495379a8"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=495379a8&lang=css"

import exportComponent from "/etc/ec/hepi_pre_prod/hepi_ui_2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__